import React from "react";

const Completed = () => {
  return (
    <svg
      aria-hidden="true"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 8L6.33653 11.9149C6.37522 11.9603 6.4448 11.9619 6.4856 11.9184L13.9091 4"
        stroke="#666666"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Completed;
